import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

export const OfferHeaderIcon = ({
  icon,
  color = '#1942C5',
  style,
}: {
  icon: IconProp
  color?: string
  style?: Record<string, string | number | undefined>
}) => (
  <FontAwesomeIcon
    icon={icon}
    // FontAwesome and MUI pull different csstype versions in this package.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    style={
      {
        width: '16px',
        height: '16px',
        fontSize: '16px',
        padding: '0px 8px 0px 0px',
        color,
        ...style,
      } as any
    }
  />
)
